import { useApiQuery } from '@apps/web/swr_data_fetching/use_api_query';

export type CommunicationCaregiver = Readonly<{
    readonly id: string;
    readonly name: string;
    readonly firstName: string | null;
    readonly lastName: string | null;
    readonly preferredName: string | null;
    readonly officeName: string | null;
}>;

const EMPTY_CAREGIVERS: ReadonlyArray<CommunicationCaregiver> = [];

export function useCommunicationCaregiverSearch({
    enabled,
    mode,
    organizationId,
    search,
}: Readonly<{
    readonly enabled: boolean;
    readonly mode: 'live' | 'sandbox';
    readonly organizationId: string;
    readonly search: string;
}>): Readonly<{
    readonly caregivers: ReadonlyArray<CommunicationCaregiver>;
    readonly failed: boolean;
    readonly isLoading: boolean;
    readonly retry: () => void;
}> {
    const query = useApiQuery({
        path: '/organizations/{organization_id}/caregivers',
        method: 'get',
        pathParams: { organization_id: organizationId },
        queryParams: { search: search.trim(), per_page: 12 },
        mode,
        enabled,
        reason: 'v3-communication-approval-caregiver-picker',
        select: (response) =>
            response.caregivers.map((caregiver) => ({
                id: caregiver.id,
                name: caregiver.name,
                firstName: caregiver.first_name ?? null,
                lastName: caregiver.last_name ?? null,
                preferredName: caregiver.preferred_name ?? null,
                officeName: caregiver.office_name ?? null,
            })),
    });

    return {
        caregivers: query.data ?? EMPTY_CAREGIVERS,
        failed: query.hasRequestFailed,
        isLoading: query.isLoading,
        retry: () => {
            void query.mutate();
        },
    };
}
